import React from 'react'

export default function Button(props) {
    return (
        <div className='button-body' style={props.bodyStyle}>
            <button className='git-btn' type={props.type} style={props.style} onClick={props.onClick}>{props.text}</button>
        </div>
    )
}